// react
import { ReactNode } from 'react';

// types
import { Contract } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink, useLocation } from 'react-router-dom';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkContractProps extends LinkProps {
	children?: ReactNode;
	contract: Contract;
	[x: string]: unknown;
}

export const LinkContract = ({ children, contract, ...props }: LinkContractProps) => {
	// hooks
	const { t } = useTranslation();
	const location = useLocation();

	// vars
	let link = <Typography>{t('na')}</Typography>;

	if (children || contract) {
		const content = children || contract.num;

		link = (
			<Link
				component={RouterLink}
				fontWeight={600}
				state={{ from: location.pathname }}
				sx={{ wordBreak: 'break-word' }}
				to={`/contracts/${contract.id}`}
				underline="hover"
				{...props}>
				{content}
			</Link>
		);
	}

	return link;
};
